/* @flow */

import type { RootState, User, UserId } from '../types'

import { selectUserById } from './usersStore'

export const STATE_KEY: string = 'currentUserId'

type SetCurrentUserIdAction = {
  type: 'opinary/SET_CURRENT_USER_ID',
  id: UserId,
}

export function setCurrentUserId(id: UserId): SetCurrentUserIdAction {
  return {
    type: 'opinary/SET_CURRENT_USER_ID',
    id,
  }
}

type UnsetCurrentUserIdAction = {
  type: 'opinary/UNSET_CURRENT_USER_ID',
}

export function unsetCurrentUserId(): UnsetCurrentUserIdAction {
  return {
    type: 'opinary/UNSET_CURRENT_USER_ID',
  }
}

export function selectHasCurrentUser(rootState: RootState): boolean {
  return !(rootState[STATE_KEY] == null)
}

export function selectCurrentUser(rootState: RootState): ?User {
  const id = rootState[STATE_KEY]
  if (id == null) {
    return null
  }
  const user = selectUserById(rootState, id)
  if (user == null) {
    throw new Error(
      `user with currentUserId ${id} expected but not found in store`
    )
  }
  return user
}

export function getCurrentUserCustomer(rootState: RootState): Object {
  const user = selectCurrentUser(rootState)
  return (user && user.customer) || {}
}

export default function reducer(
  state: ?UserId = null,
  action: SetCurrentUserIdAction | UnsetCurrentUserIdAction
): ?UserId {
  switch (action.type) {
    case 'opinary/SET_CURRENT_USER_ID':
      return action.id
    case 'opinary/UNSET_CURRENT_USER_ID':
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/currentUser.js